<template>
  <div class="footer">
    <a><img src="./../assets/images/Logo-1-min.png"></a>
    <a><img src="./../assets/images/Logo-2-min.png"></a>
    <a><img src="./../assets/images/Logo-3-min.png"></a>
    <a><img src="./../assets/images/Logo-4-min.png"></a>
  </div>
</template>

<script>
export default {
  name: 'IconFooter',
  data () {
    return {
      msg: 'Cloetta'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footer {
    background-color: #000;
    position: absolute;
    bottom: 0px;
    left: 0px;
    height: 9%;
    width: 100%;
    box-sizing: border-box;
  }
  .footer a {

  }
  .footer a img {
    height: 4.3vh;
    margin-top: 2.6vh;
    margin-left: 2vh;
    margin-right: 2vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/IconFooter.vue